(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["knotz-product-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('knotz-product-tabs')) {
    customElements.define('knotz-product-tabs', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.addEventListener('click', event => {
          const tab = event.target.closest('[role="tab"]');
          if (tab && this.contains(tab)) this.activate(tab);
        }, { signal: this.controller.signal });
        this.addEventListener('keydown', event => {
          const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          const index = tabs.indexOf(event.target);
          if (index < 0) return;
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.activate(tabs[next]);
          tabs[next].focus();
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
      activate(selectedTab) {
        this.querySelectorAll('[role="tab"]').forEach(tab => {
          const selected = tab === selectedTab;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.querySelectorAll('[role="tabpanel"]').forEach(panel => {
          panel.hidden = panel.id !== selectedTab.getAttribute('aria-controls');
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
